import React, {useContext} from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch
} from "react-router-dom";
import EventsCreate from "./EventsCreate";
import EventsTimeline from "./EventsTimeline/EventsTimeline";
import EventsDetailedView from "./EventsTimeline/EventsDetailedView";
import EventsSchedule from "./EventsSchedule";
import {store} from "../store";
import {hasScope} from "../helpers/scopes";

export default function Events() {
  let match = useRouteMatch();
  const {state} = useContext(store);

  return (
    <Switch>

      <Route path={`${match.path}/schedule`}>
        <EventsSchedule />
      </Route>
      <Route path={`${match.path}/list/:mode?/:year?/:month?/:dayOfMonth?`}>
        <EventsTimeline />
      </Route>
      <Route path={`${match.path}/create`}>
        {hasScope(state.user, 'events:write') ? <EventsCreate /> : <Redirect to={`${match.path}/list`} />}
      </Route>
      <Route path={`${match.path}/view/:id`}>
        <EventsDetailedView />
      </Route>
    </Switch>
  );
}
